<template>
  <div class="page">
    <ul class="poly-clss-more menu-main">
      <li class="poly-class" @click="showWhole()">
        <p>
          <span class="one">全部</span>
        </p>
      </li>
      <li class="poly-class" @click="showClass(proList)">
            <p>
                <span class="van-ellipsis">{{ className }}</span>
                <span class="iconfont icon-zhankai-01 class-icon-col poly-class-icon"></span>
            </p>
        </li>
      <!-- <li class="poly-class" v-for="item in proList" :key="item.id" @click="showClass(item.children)">
          <p>
            van-ellipsis  
              <span class="van-multi-ellipsis--l2">{{ item.title }}</span>
              <span class="iconfont icon-zhankai-01 class-icon-col poly-class-icon"></span>
          </p>
      </li> -->
    </ul>
    <!-- <van-tabs class="menu-main">
      <van-tab v-for="item in proList" :key="item.id" :title="item.title">
        <div class="two-menu">
          <span @click="handleMenu(ite.id)" :class="ite.id == menuId ? 'active': ''" v-for="ite in item.children" :key="ite.id">{{ ite.title }}</span>
        </div>
      </van-tab>
    </van-tabs> -->
    <ul class="poly-pdf">
        <li v-for="(item,index) in pdfList" :key="item.id">
          <div class="poly-pdf-item" v-for="ite in item" :key="ite.id"  @click="selPdf(ite)">
            <div class="poly-pdf-con " :class="ite.isSelect ? 'poly-active': ''">
              <div class="poly-pdf-img">
                <span v-if="ite.num > 0" class="pdf-badge">{{ ite.num }}</span>
                <van-image class="pdf-column-img" src="https://cdn.juplus.cn/FpZLVFiI3F_xTiGu_iKgLBJ4dDBc" />
                <van-image class="slider-img" :class="ite.isSelect ? 'slid-img-active': ''" :src="cdnUrl + ite.cover" />
              </div>
            </div>
            <p class="van-multi-ellipsis--l3 m-t-p-4">{{ ite.title }}</p>
          </div>
          <van-image class="line-img" :src="cdnUrl + 'FpbDagHQtx0PpyHqV9JXdsvIRF7u'" />
        </li>
        <!--   -->
        <!--  -->
    </ul>

    <div class="oper-btn">
      <p class="text-col">注：可选择多个样本进行批量操作</p>
      <div class="oper-btn-content">
        <p class="oper-btn-p" @click="handleDown" v-show="isModel != '1'">
          <span class="iconfont icon-bendixiazai-011 icon-col"></span>
          <span>本地下载</span>
        </p>
        <p class="line-btn" v-show="isModel != '1'"></p>
        <p class="oper-btn-p" @click="handleShareEmail">
          <span class="iconfont icon-youjianfenxiang-011 icon-col"></span>
          <span>邮件分享</span>
        </p>
      </div>
    </div>
    <div class="oper-btn" v-show="isDown || isShare">
      <p class="text-col">注：可选择多个样本进行批量操作</p>
      <div class="oper-btn-content">
        <p class="oper-btn-p" @click="handleSelPdf">
          <span class="iconfont icon-bendixiazai-011 icon-col"></span>
          <span>查看已选择({{ checkPicList.length }})</span>
        </p>
        <p class="line-btn"></p>
        <p class="oper-btn-p" v-show="isDown" @click="handleSureDown">
          <span class="iconfont icon-youjianfenxiang-011 icon-col"></span>
          <span>确定下载</span>
        </p>
         <p class="oper-btn-p" v-show="isShare" @click="handleSureShare">
          <span class="iconfont icon-youjianfenxiang-011 icon-col"></span>
          <span>确定分享</span>
        </p>
      </div>
    </div>
    <!-- 表单 -->
    <customer-form ref="customerForm" :formItem="applyFormItem" :formDataList="applyFormDataList" @handleSon="handleSon" :showACode="1"></customer-form>
    <!-- 邮箱分享 -->
    <share-email ref="shareEmail" :pdfIds="ids" @setEmail="setEmail"></share-email>
    <!-- 确定框 -->
    <message ref="sureMessage" :title="tipOk"></message>
    <!-- 查看pdf -->
    <view-selection ref="pdfSelect" :isEmail="isEmail" :sumTotal="sumTotal" @handleCancelPdf="handleCancelPdf" :pdfList="checkPicList" @downFile="downFile" :isModel="isModel"></view-selection>

    <van-popup
      v-model="showBottom"
      position="bottom"
      :style="{ height: '40%' }"
      class="vant-boottom"
    >
      <!-- <van-picker :columns="columns" value-key="title" title="" @change="onChange" show-toolbar
        @cancel="showBottozzzzzzzm = false" @confirm="onConfirm"/> -->
        <van-checkbox-group v-model="newCid" direction="horizontal" style="padding: 0 12px;padding-top: 53px;" ref="checkboxGroup" @change="onChange($event)">
            <van-checkbox v-for="item in columns" :key="item.id" :name="item.id" checked-color="#5BC4DC">{{ item.title }}</van-checkbox>
        </van-checkbox-group>
        <div class="main-btn">
            <button class="send-container btn-cal" @click.stop="showBottom = false">取消</button>
            <button class="send-container" @click.stop="handleSure">确定</button>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { getOS } from '@/libs/util'
import customerForm from '@/views/polymerize/components/customer-form'
import shareEmail from '@/views/polymerize/components/shareEmail'
import message from '@/views/polymerize/components/message'
import viewSelection from '@/views/polymerize/components/viewSelection'
import { getpolyPdf,sendEmail,getpolyClass,getForm,getpolyDetail,setdownShare } from '@/api/polymerize'
import config from '@/config'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import { wxShare } from '@/libs/wxjssdk'
export default {
  components: { customerForm,shareEmail,message,viewSelection },
  data () {
    return {
      cdnUrl: this.$config.baseUrl.cdnUrl,
      baseUrl: window.location.origin + '/',
      id: '', // 聚合详情id
      formId: '', // 聚合表单id
      menu: [],
      pdfList: [],
      menuId: [], // 二级菜单
      tipOk: '发送成功',
      applyFormDataList: [],
      applyFormItem: {},
      checkPicList: [], // 存储选中的
      isModel: 0, // 设备型号  1  ios  2  Android
      isDown: false, // 下载确定（显示下载）
      isShare: false, // 分享确定显示
      ids: [], // 选中的id
      proList: [], // 分类列表
      user_exists: false, // 是否填写过 true -- 填写过 false -- 未填写
      showBottom: false,
      columns: [],
      newCid: [],
      browserUserId: '',
      className: '分类',
      sumTotal: 0, // 总数
      isEmail: false, // 安卓点击邮件分享记录
    }
  },
  mounted() {
    let { id, uid, formId, classId, className } = this.$route.query
    this.id = id
    this.browserUserId = uid
    this.formId = formId
    this.newCid = classId.split(',')
    this.newCid = this.newCid.map(i => parseInt(i, 0))
    this.className = className
    this.isModel = getOS()
    this.$refs.customerForm.formId = this.formId
    this.getClassList(this.newCid)
    this.getDetail()
    
    if (this.formId) {
      this.getFormInfo()
    }
    console.log('分类id',this.newCid);
  },
  methods: {
    showClass(data) {
      this.showBottom = true
      // this.newCid = []
      this.columns = data
    },
    onChange(val) { // 二级选择
      this.newCid = val
    },
    handleSure() {
      let namelist = []
      const newList = this.columns.filter((item) =>{
          if(this.newCid.includes(item.id)) {
              namelist.push(item.title)
          }
      });
      if (namelist.length > 0) {
        this.className = namelist.join(',')
      }
      this.getPdfList(this.newCid)
      this.showBottom = false
    },
    showWhole() {
      this.menuId = ''
      this.className = '分类'
      this.getPdfList()
    },
    onConfirm(data) {   // 二级确定
      this.menuId = data.id
      this.className = data.title
      this.getPdfList()
      this.showBottom = false
    },
    sharePage () {
      const params = {
        title: this.shareData.title, // 分享标题
        desc: this.shareData.desc, // 分享描述
        link: `${window.location.href.split('#')[0]}#/classDetail?id=${this.shareData.id}&formId=${this.formId || ''}`, // 分享链接
      }
      wxShare(params)
    },
    handleSon(data) { // 处理表单提交后（下载，分享）
      console.log('处理表单提交后',data);
      if (data == '1') { // 下载
        // console.log('处理111',data);
        this.isDown = true
      } else { // 分享
        this.isShare = true
      }
      this.getDetail()
    },
    setEmail(email) { // 发送邮箱记录
      this.setDownShare('2',email)
    },
    getDetail() { // 聚合详情
      getpolyDetail({id: this.id,uid: this.$store.state.user.id || this.browserUserId}).then(res => {
        this.shareData = res.data
        this.user_exists = res.data.user_exists
        this.sharePage()
      })
  },
    getClassList(newCid) { // 分类列表
      getpolyClass({group_id: this.id}).then(res => {
        this.proList = res.data
        // this.menuId = res.data[0].children[0].id
        this.getPdfList(newCid)
      })
    },
    getFormInfo() { // 表单
      getForm({id: this.formId}).then(res => {
        this.applyFormDataList = res.data.keys

      })
    },
    handleMenu(id) { // 选择二级菜单
      this.menuId = id
      this.getPdfList()
    },
    getPdfList(category) { // pdf列表
      let para = {
        group_id: this.id,
        cid: category || []
      }
      getpolyPdf(para).then(res => {

        this.pdfList = res.data
        this.echoPdf()

      })
    },
    echoPdf() { // 回显pdf
       this.pdfList.forEach(ele => {
        ele.forEach(el => {
          this.checkPicList.forEach(item => {
            if(el.id == item.id) {
              el.isSelect = item.isSelect
              el.num = item.num
            }
          })
        })
      })
      // console.log('绑定的pdf',this.pdfList);
    },
    selPdf(item) { // 选择pdf
      let activeIndex = 0
      if (item.isSelect) {
        item.isSelect = false
        this.checkPicList.map((el, index) => {
          if (el.id == item.id) {
            activeIndex = index;
          }
        });
        this.checkPicList.splice(activeIndex, 1);
      } else {
        item.isSelect = true
        this.checkPicList.push(item);
      }
      // console.log('选中得得',this.checkPicList);
      this.ids = []
      this.checkPicList.map((item, i) => {
        this.ids.push(item.id)
      })

      this.compareSelected()
      // console.log('最后',this.pdfList);
      this.$forceUpdate()
    },
    handleCancelPdf(item) {
      // console.log('父级的',item);
      this.selPdf(item)
    },
    compareSelected() { // 选中状态
      this.pdfList.forEach((el, i) => {
        el.map((ite,ind) => {
          if (ite.isSelect) {
            this.checkPicList.filter((el2, j) => {
              if (ite.id == el2.id) {
                ite.num = j + 1
              }
            });
          } else {
            ite.num = 0
            ite.isSelect = false
          }
        })
      })
    },
    handleDown() { // 下载
    console.log('--',this.user_exists);
      if (this.ids.length == 0) {
        this.$toast('请先选择再进行下载')
      } else {
        if (this.formId && !this.user_exists) {
          this.addPhoneCode()
          this.$refs.customerForm.downorshare = '1' // 下载
          this.$refs.customerForm.showApplyForm()
        } else {
          this.isDown = true // 显示下载
        }

      }
      // this.isDown = true
    },
    handleSureDown() { // 确定下载
      if (this.ids.length == 0) {
        this.$toast('请先选择再进行下载')
        return
      }
      // this.setDownShare('1')
      if (this.isModel == '1') { // ios
        this.$refs.shareEmail.downorshare = '1' //  邮件 -- 下载
        this.$refs.shareEmail.showEmail()
      } else { // 安卓
        this.downFile()
      }
    },
    download(url, filename) {
      
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer'; // blob
      xhr.setRequestHeader('Content-Type', `application/pdf`);
      // responseType: 'arraybuffer',
      xhr.onload = function () {
        
        var blob = new Blob([xhr.response], {
          'type': 'application/pdf' // ;chartset=UTF-8
        })
        console.log('操作',blob)
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            let link = document.createElement('a');
            let body = document.querySelector('body');
            link.href = window.URL.createObjectURL(blob); // 
            // link.download = filename;
            link.style.display = 'none';
            link.setAttribute("download", filename)
            body.appendChild(link);
            console.log('操作===',link.href)
            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          };
        }
      };
      xhr.send();
    },
    //文件以流的形式获取
    getImgArrayBuffer(url) {//url为文件地址
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    downFile(pdfList) {
      this.setDownShare('1')
      var blogTitle = `下载pdf`;
      var zip = new JSZip();
      var promises = [];
      let cache = {};
      // 要下载图片的url
      let arrImg = [];
      console.log('下载了',this.checkPicList);
        //fileList问下载的文件的全连接地址集合
      for (let i = 0; i < this.checkPicList.length; i++) {
        arrImg.push({
          path: this.baseUrl +  this.checkPicList[i].pdf_url,
          name: this.checkPicList[i].title + '.pdf'
        });
      }
      // console.log('下载的',arrImg);
      for (let item of arrImg) {
        const promise = this.getImgArrayBuffer(item.path).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.name, data, { binary: true }); // 逐个添加文件
          cache[item.name] = data;
        });
        promises.push(promise);
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  自定义文件名
            // this.btnLoading = false;
            this.$router.push({
              name: 'polyDetail',
              query: {
                id: this.id,
                uid: this.$route.query.uid
              }
            })
          });
        })
        .catch((res) => {
          this.$message.error("文件压缩失败");
        });
    },
    addPhoneCode() { // 添加验证码
      this.applyFormDataList.forEach(item => {
        if (item.type === 2) {
          this.applyFormItem[item.field] = []
        } else {
          this.applyFormItem[item.field] = ''
        }
      })
      let moIndex = ''
      this.applyFormDataList.filter((value,index) => {
        if (value.field == 'mobile') {
          moIndex = index
        }
        if(value.field == 'code') {
          moIndex = false
        }
      })

      if (moIndex) {
        let moblie = {
          field: 'code',
          required: 1,
          title: '验证码',
          type: 3,
          value: "",
          placeholder: "请输入验证码"
        }
        this.applyFormDataList.splice(moIndex+1, 0, moblie)
      }
    },
    handleShareEmail() { // 邮件分享
      if (this.ids.length == 0) {
        this.$toast('请先选择再进行分享')
      } else {
        this.isEmail = true
        if (this.formId && !this.user_exists) {
          this.addPhoneCode()
          this.$refs.customerForm.downorshare = '2' // 分享
          this.$refs.shareEmail.downorshare = '2' // 邮件 -- 分享
          this.$refs.customerForm.showApplyForm()
        } else {
          this.isShare = true
        }

      }
      // this.$refs.sureMessage.showMessge() // 确定
    },
    handleSureShare() {

      this.$refs.shareEmail.downorshare = '2' // 邮件 -- 分享
      this.$refs.shareEmail.showEmail()
    },
    setDownShare(action,value) {
      let ids = []
      this.checkPicList.map((item, i) => {
        ids.push(item.id)
      })
      let para = {
        type: 1,
        type_id: this.id,
        action: action, // 1 下载 2 分享
        value: value || '',
        user_id: this.$store.state.user.id ? this.$store.state.user.id : this.$route.query.uid,
        pdf_id: ids
      }
      console.log('分享的',para);
      setdownShare(para).then(res => {})
    },
    handleSelPdf() { // 查看选中的pdf
      let index = this.checkPicList.map(val => {
        return val.size.split(' ')[0]
      })
      this.sumTotal = this.sum(index).toFixed(2) // Math.floor(this.sum(index)) 
      console.log('knaxia',this.ssumTotal);
      this.$refs.pdfSelect.showPdfList() // pdf列表
    },
    sum(arr) {
      return eval(arr.join("+"));
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-checkbox-group--horizontal {
        
  justify-content: start;
  box-sizing: border-box;
}
.vant-boottom {
    padding-bottom: rem(70);
    ::v-deep .van-checkbox {
      display: flex;
      flex-flow: row-reverse;
      justify-content: space-between;
      min-width: 109px;
      padding-bottom: 10px;
      width: 100%;
      border-bottom: 1px solid #ccc;
      margin-bottom: 15px;
    }
}


::v-deep .van-checkbox--horizontal {
  margin-right: 0;
}
.page {
  height: 100vh;
  background: #F6F6F6;
}
.m-t-p-4 {
    margin-top: rem(4);
    padding: 0 rem(3);
    box-sizing: border-box;
}
.text-col {
  text-align: center;
  margin-bottom: rem(6);
  color: $poly-color;
}
.menu-main {
  background-color: #fff;
  box-shadow: 0px 3px 4px 0px rgba(0,0,0,0.05);
  .two-menu {
    margin-top: rem(21);
    padding-left: rem(16);
    span {
      display: inline-block;
      margin: 0 rem(16) rem(16) 0;
      padding: rem(6) rem(16);
      border: 1px solid #999999;
      border-radius: rem(4);
    }
    .active {
      color: rgba(12, 104, 169, .5);
      background: linear-gradient(135deg, #F6FCFF 0%, #EEF9FF 100%);
      border: 1px solid rgba(12, 104, 169, .5);
    }
  }
}

.poly-pdf {
  display: flex;
  flex-wrap: wrap;
  margin-top: rem(16);
  padding: 0 rem(26) rem(60) rem(26);
  li {
    display: flex;
    flex-wrap: wrap;
  }
  .poly-pdf-item {
    width: rem(96);
    margin-top: rem(16);
    margin-right: rem(15);
  }
  .poly-pdf-item:nth-child(3n) {
      margin-right: 0;
  }
  .poly-pdf-con {
    width: rem(96);
    height: rem(126);
    background: rgba(244, 246, 248,0.5);
    box-shadow: 2px 2px 4px 0px rgba(12,104,169,0.1), 2px 2px 4px 0px rgba(168,168,168,0.1);
    box-sizing: border-box;
    border-radius: rem(4);
  }

  .poly-pdf-img {
    position: relative;
    padding: rem(8);
    border-radius: 0 rem(4) rem(4) 0;
    box-sizing: border-box;
    .pdf-column-img {
      position: absolute;
    }
    .pdf-badge {
      position: absolute;
      right: 12px;
      display: inline-block;
      width: rem(20);
      height: rem(20);
      line-height: rem(20);
      text-align: center;
      color: #fff;
      background-color: $poly-color;
      border-radius: 50%;
      z-index: 1;
    }
  }
  .poly-active {
    border: 1px solid $poly-color;
  }
  .slid-img-active {
    box-shadow: 2px 2px 4px 0px rgba(12,104,169,0.1), 2px 2px 4px 0px rgba(168,168,168,0.1);
  }
  .slider-img {
    border-radius: rem(4);
  }
  .line-img {
    margin-top: rem(25);
  }
}
.oper-btn {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-top: rem(8);
  background-color: #fff;
  .oper-btn-content {
    display: flex;
    align-items: center;
    height: rem(49);
    color: #fff;
    background-color: #6CC5DB;
    .oper-btn-p {
      display: flex;
      flex: 1;
      height: 100%;
      justify-content: center;
      align-items: center;
    }
  }
  .line-btn {
    width: 1px;
    height: 80%;
    background-color: #fff;
  }
  .icon-col {
    font-size: rem(18);
    margin-right: rem(9);
    vertical-align: bottom;
  }
}
::v-deep .van-tab--active {
  color: $poly-color;
}
::v-deep .van-tabs__line {
  bottom: 20px;
  height: 2px;
  background-color: $poly-color;
}
.poly-clss-more {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  padding: 0  rem(16) rem(20) rem(16);
  .poly-class {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: rem(120);
      height: rem(40);
      margin-top: rem(16);
      margin-right: rem(8);
      background: linear-gradient(135deg, #F6FCFF 0%, #EEF9FF 100%);
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.03);
      border-radius: 4px;
      box-sizing: border-box;
      p {
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
  }
  .class-icon-col {
      color: $poly-color;
      // transform: rotate(180deg);
  }
  .poly-class-icon {
      text-align: right;
      transform: rotatex(180deg);
      span {
          font-size: rem(12);
      }
  }
}
.btn-main {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: rem(10) 0;
    background-color: #fff;
    box-shadow: 1px -7px 6px 0px rgba(0,0,0,0.05);
    box-sizing: border-box;
}

.down-btn {
    // position: fixed;
    // left: 50%;
    // bottom: rem(10);
    // transform: translateX(-50%);
    display: inline-block;
    width: 60%;
    height: rem(40);
    line-height: rem(40);
    font-size: 17px;
    text-align: center;
    color: #fff;
    background: $base-color;
    border-radius: rem(10);
}
.main-btn {
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: rem(10) 0;
    background-color: #fff;
    box-shadow: 1px -7px 6px 0px rgba(0,0,0,0.05);
}
.send-container{
    display: block;
    width: rem(114);
    height: rem(39);
    font-size: 13px;
    outline: none;
    border: none;
    background: #6CC5DB;
    color: #FEFEFE;
    border-radius:4px;
}
.btn-cal {
    margin-right: rem(8);
    background-color: #ccc;
}
</style>